import { CloudUpload } from 'lucide-react';

import { Alert, AlertTitle, AlertDescription } from '@/components/ui/alert';
import { SyntaxHighlighter } from '@/components/ui/syntax-highlighter';
import { Link } from 'react-router-dom';
import PATH_PAGE from '@/router/path';
import useParamWorkspaceId from '@/hook/useParamWorkspaceId';

const OnboardingInfoCreateProject = () => {
  const { orgId, workspaceId } = useParamWorkspaceId();
  return (
    <div>
      <Alert variant={'info'}>
        <CloudUpload className="h-4 w-4" />
        <AlertTitle>Project not found</AlertTitle>
        <AlertDescription>
          To create a project, enter your shell and run this command from the
          working directory.
          <div className="mt-2 max-w-[600px]">
            <SyntaxHighlighter language="bash" showCopy>
              {`float16 project create`}
            </SyntaxHighlighter>
          </div>
          <div className="mt-2">
            <Link
              to={PATH_PAGE.dashboard.serverlessGPU.onboarding(orgId, workspaceId)}
              className="underline"
            >
              Full Quickstart guide.
            </Link>
          </div>
        </AlertDescription>
      </Alert>
    </div>
  );
};

export default OnboardingInfoCreateProject;
